import { Link } from "react-router-dom";

export  const serviceData = [
    {
      id: 1,
      title:'Facility Management Services',
      detail:'Facility Management Services relates arrangement for professional maintenance....',
      link:'/',
    },
    {
      id: 2,
      title:'House Keeping Services',
      detail:'Housekeeping is the department that deals with the cleanliness & all ancillary services...,',
      link:'/',
    },
    {
        id: 3,
        title:'Pantry Services',
        detail:'A pantry is an area where Tea, Coffee, Dishes, Food or Eatables things are stored....',
        link:'/',
    },
    {
      id: 4,
      title:'Support Staff Services',
      detail:'Support Staff Services to provide support for products & services for company....',
      link:'/',
    },
    {
      id: 5,
      title:'Pest control Services',
      detail:'Presence of Pests, Rodent & Termite such as flies, bugs, ants, roaches and mice in premises….',
      link:'/',
    },
    {
      id: 6,
      title:'Carpet & Sofa Cleaning',
      detail:'There is always a sense of joy & fulfillment when you feel that you have received good….',
      link:'/',
    },
    {
      id: 7,
      title:'Facade/Glass Cleaning Services',
      detail:'A pantry is an area where Tea, Coffee, Dishes, Food or Eatables things are stored....',
      link:'/',
    },
    {
      id: 8,
      title:'Gardening Services',
      detail:'Maintenance of garden is practiced from the individual level to upto the professional…',
      link:'/',
    },
    {
      id: 9,
      title:'Security Services',
      detail:'Security is the most crucial issue for any organization. As the unlawful activities are….',
      link:'/',
    },
    {
      id: 10,
      title:'Electro-Mechanical Services',
      detail:'SSOS specialized in Maintenance services to commercial & corporate infrastructure….',
      link:'/',
    },
    {
      id: 11,
      title:'HVAC Services',
      detail:'Heating, Ventilation and Air Conditioning (HVAC) system are very importent part of….',
      link:'/',
    },
    {
      id: 12,
      title:'Plumbing Services',
      detail:'Plumbing is a very important service to serve your commercial plumbing needs is timely courteous….',
      link:'/',
    },
  ];
  export const data = [
    {
      id:1,
      image:'https://img.freepik.com/free-photo/low-angle-closeup-person-cleaning-floor-with-mop-near-yellow-caution-wet-floor-sign_181624-37077.jpg?w=1380&t=st=1670054725~exp=1670055325~hmac=f4a8202753fa815c8fea91041d0d0c8b77ee5e5e710b3a0adfb7480ee8e7ffb4',
      heading:'Facility Management Service Provider',
      para:'SSOS is a leading Facility Management Service Provider in Gurgaon. We have a wide experience in facility management domain & also a expertise team of more than 200 professional for excellent client service.',
      
  },   
]
export const clientData=[
  {
    id:1,
    title:'CARIOT AUTO PRIVATE LIMITED',
    imsrc:'https://media-exp1.licdn.com/dms/image/C4E0BAQE-va7qFT0xSQ/company-logo_100_100/0/1519905860932?e=2147483647&v=beta&t=laGajkYZRUL_52hn4x7Vogopd77gc_6Pw4FOH_KSf7o',
    name:'cariot'
  },
  {
    id:2,
    title:'AVERY DENNISON (INDIA) PRIVATE LIMITED',
    imsrc:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRafVuqH4TIAe1PK-zKMCodD9hFoh3ERM_lAPATJ5wGT2Q4Rz7D7jwCi2hVBTAewrGjjS4&usqp=CAU",
    name:'avery'
  },
  {
    id:3,
    title:'CARS24 SERVICES PRIVATE LIMITED',
    imsrc:'https://upload.wikimedia.org/wikipedia/commons/5/5f/Cars24logo.png',
    name:'cars24'
  },
  {
    id:4,
    title:'GUARDIAN INDIA OPERATIONS PRIVATE LIMITED',
    imsrc:'https://d2q79iu7y748jz.cloudfront.net/s/_squarelogo/256x256/198d722eeb819f982dc02f3892a1bc36',
    name:'guardian'
  },
  {
    id:5,
    title:'UNIMRKT RESEARCH PRIVATE LIMITED',
    imsrc:'https://www.unimrkt.com/images/logo.png',
    name:'unimrkt'
  },
  {
    id:6,
    title:'YATRA ONLINE PRIVATE LIMITED',
    imsrc:'https://mma.psjewswire.com/media/512422/Yatra_Online__Inc_Logo.jpg',
    name:'yatra'
  },
  {
    id:7,
    title:'TEOCO SOFTWARE PRIVATE LIMITED',
    imsrc:'https://media.glassdoor.com/sqll/12167/teoco-squarelogo-1389051005880.png',
    name:'teoco'
  },
]
export const delhiRowData=[
  {
    id:1,
    heading:'Name/address of Website',
    detail:(<Link className='text-teal-600' to='#'>www.ssos.co.in</Link>),
  },
  {
    id:2,
    heading:'Name of the Establishment',
    detail:'Shining Star Outsource Services Private Limited',
  },
  {
    id:3,
    heading:'Address of the Establishment ( Registered Office )',
    detail:'5th Floor SCO 61, Old Judicial Complex, Sector 15 Gurugram, Haryana, India, PIN - 122001',
  },
  {
    id:4,
    heading:'Address of the Clients',
    detail:('cars24 plus-Metro Walk,Rohini Delh '),
  },
  {
    id:5,
    heading:'Nature of work',
    detail:'Manpower Outsource',
  },
  {
    id:6,
    heading:'Name of the Director',
    detail:'Ms. Soni',
  },
  {
    id:7,
    heading:'Date of starting of Business',
    detail:'01/07/2013',
  },
  {
    id:8,
    heading:'Date of Initial agreement with the Principal Employer ( working since with PE )',
    detail:'11/09/2020',
  },
  {
    id:9,
    heading:'Mobile No.',
    detail:9999639635,
  },
  {
    id:10,
    heading:'E-mail ID',
    detail:<Link className='text-teal-600'>rn@ssos.co.in</Link>,
  },
  {
    id:12,
    heading:'Registration Certificate No. of PE / Contractor Labour License No. and valid up to',
    detail:<Link className='text-teal-600'>PSA/REG/GGN/DIC-GGN-I/0011775 </Link>,
  },
  {
    id:15,
    heading:'Registration No. under the Companies Act, 1956',
    detail:<Link className='text-teal-600'>N/A </Link>,
  },
  {
    id:16,
    heading:'Registration No. under the Haryana Shop & Establishment Act, 1954',
    detail:<Link className='text-teal-600'>PSA/REG/GGN/LI-GGN-3-7/0171010</Link>,
  },
  {
    id:17,
    heading:'Registration No. under the Factofories Act ( for PE)',
    detail:<Link className='text-teal-600'>N/A </Link>,
  },
  {
    id:18,
    heading:'Registration No. or Employes ESIC Act, 1948',
    detail:<Link className='text-teal-600'>69000530840001001</Link>,
  },
  {
    id:19,
    heading:'Registration No. EPF and Misc. Provisions Act, 1952',
    detail:<Link className='text-teal-600'>GNGGN0033453000</Link>,
  },
  // {
  //   id:20,
  //   heading:'Service Tax Registration No',
  //   detail:<Link className='text-teal-600'>AATCS3238GSD001</Link>,
  // },
  // {
  //   id:21,
  //   heading:'Sale Tax Registration No.  ',
  //   detail:<Link className='text-teal-600'>06551950852</Link>,
  // },
  {
    id:22,
    heading:'PAN Card No.',
    detail:<Link className='text-teal-600'>AATCS3238G</Link>,
  },
]
export const hyderabadRowData=[
  {
    id:1,
    heading:'Name/address of Website',
    detail:(<Link className='text-teal-600' to='#'>www.ssos.co.in</Link>),
  },
  {
    id:2,
    heading:'Name of the Establishment',
    detail:'Shining Star Outsource Services Private Limited',
  },
  {
    id:3,
    heading:'Address of the Establishment ( Registered Office )',
    detail:'5th Floor SCO 61, Old Judicial Complex, Sector 15 Gurugram, Haryana, India, PIN - 122001',
  },
  {
    id:4,
    heading:'Address of the Clients',
    detail:('Cars24 - Sy. No-165, Upperpally Village, RR Nagar, Municipality District, RR District Telangana 500048'),
  },
  {
    id:5,
    heading:'Nature of work',
    detail:'Manpower Outsource',
  },
  {
    id:6,
    heading:'Name of the Director',
    detail:'Ms. Soni',
  },
  {
    id:7,
    heading:'Date of starting of Business',
    detail:'01/07/2013',
  },
  {
    id:8,
    heading:'Date of Initial agreement with the Principal Employer ( working since with PE )',
    detail:'11/09/2020',
  },
  {
    id:9,
    heading:'Mobile No.',
    detail:9999639635,
  },
  {
    id:10,
    heading:'E-mail ID',
    detail:<Link className='text-teal-600'>sj@ssos.co.in</Link>,
  },
  {
    id:12,
    heading:'Registration Certificate No. of PE / Contractor Labour License No. and valid up to',
    detail:<Link className='text-teal-600'>PSA/REG/GGN/DIC-GGN-I/0011775 </Link>,
  },
  {
    id:15,
    heading:'Registration No. under the Companies Act, 1956',
    detail:<Link className='text-teal-600'>N/A </Link>,
  },
  {
    id:16,
    heading:'Registration No. under the Haryana Shop & Establishment Act, 1954',
    detail:<Link className='text-teal-600'>PSA/REG/GGN/LI-GGN-3-7/0171010</Link>,
  },
  {
    id:17,
    heading:'Registration No. under the Factofories Act ( for PE)',
    detail:<Link className='text-teal-600'>N/A </Link>,
  },
  {
    id:18,
    heading:'Registration No. or Employes ESIC Act, 1948',
    detail:<Link className='text-teal-600'>69000530840001001</Link>,
  },
  {
    id:19,
    heading:'Registration No. EPF and Misc. Provisions Act, 1952',
    detail:<Link className='text-teal-600'>GNGGN0033453000</Link>,
  },
  // {
  //   id:20,
  //   heading:'Service Tax Registration No',
  //   detail:<Link className='text-teal-600'>AATCS3238GSD001</Link>,
  // },
  // {
  //   id:21,
  //   heading:'Sale Tax Registration No.  ',
  //   detail:<Link className='text-teal-600'>06551950852</Link>,
  // },
  {
    id:22,
    heading:'PAN Card No.',
    detail:<Link className='text-teal-600'>AATCS3238G</Link>,
  },
]
// export const url = 'https://ssos-compliance.onrender.com';
export const url = 'http://localhost:4000';